module.exports = {"googleAnalytics":[{"key":"UA-39642447-1"}]}


//////////////////
// WEBPACK FOOTER
// ./htdocs/content/themes/tpt-national/assets/js/environments/publicAPIKeys.production.json
// module id = 12
// module chunks = 0 1 4